/* eslint-disable prefer-const */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/order */
/* eslint-disable object-shorthand */
/* eslint-disable prettier/prettier */
import { Icon } from '@iconify/react';
import { useEffect, useRef, useState } from 'react';
import skipBackOutline from '@iconify/icons-eva/skip-back-outline';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
// material
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  TextField,
  Grid,
  CardHeader,
  SpeedDial,
  SpeedDialIcon,
  SpeedDialAction,
  Box
} from '@mui/material';
// components
import Page from '../components/Page';
import { useFormik } from 'formik';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// eslint-disable-next-line import/no-named-as-default-member
import MyDropzone from 'src/components/MyDropzone';
import axios from 'axios';
import { config } from 'src/helpers/config';
import SaveIcon from '@mui/icons-material/Save';
import authHeader from 'src/helpers/authHeader';
import { DesktopDatePicker, LocalizationProvider } from '@mui/lab';
import 'react-datepicker/dist/react-datepicker.css';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { NotificationManager } from 'react-notifications';

const validationSchema = yup.object({
  name: yup.string('Wprowadź tytuł').required('To pole jest obowiązkowe')
});

export default function PageContent() {
  const { name } = useParams();

  const save = (values) => {
    axios
      .put(
        `${config.apiAdminUrl}pageContent`,
        {
          ...values
        },
        {
          headers: {
            ...authHeader()
          }
        }
      )
      .then(() => {
        NotificationManager.success('Zawartosć strony została zaktualizowana!', '', 3000);
      })
      .catch((e) =>
        NotificationManager.error('Wystąpił błąd! Skontaktuj się z Łukaszem!', '', 3000)
      );
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      content: ''
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      save(values);
    }
  });

  useEffect(() => {
    console.log(name);
    if (name) {
      axios
        .get(`${config.apiAdminUrl}pageContent/${name}`, {
          headers: { ...authHeader() }
        })
        .then((e) => {
          formik.setValues({
            content: e.data.result.content
          });
        });
    }
  }, []);

  return (
    <Page title="User | Minimal-UI">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Wizyta
          </Typography>
          <span>
            <Button
              sx={{
                marginRight: '5px'
              }}
              variant="contained"
              component={RouterLink}
              to="/dashboard"
              startIcon={<Icon icon={skipBackOutline} />}
            >
              Wróć
            </Button>
          </span>
        </Stack>
        <Card
          sx={{
            padding: '25px'
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CKEditor
                  editor={ClassicEditor}
                  data={formik.values.content}
                  config={{
                    ckfinder: {
                      // Upload the images to the server using the CKFinder QuickUpload command.
                      uploadUrl: `${config.apiAdminUrl}image`,
                      headers: { ...authHeader() }
                    }
                  }}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    formik.setFieldValue('content', data);
                  }}
                />
              </Grid>
              <SpeedDial
                ariaLabel="SpeedDial basic example"
                sx={{ position: 'fixed', bottom: 16, right: 16 }}
                icon={<SpeedDialIcon />}
              >
                <SpeedDialAction
                  component={Button}
                  type="submit"
                  icon={<SaveIcon />}
                  tooltipTitle="Zapisz"
                />
              </SpeedDial>
            </Grid>
          </form>
        </Card>
      </Container>
    </Page>
  );
}
